module.exports = __webpack_public_path__ + "img/occupation_forget_de.cb805540.svg";